module.exports = __webpack_public_path__ + "img/skiing_with_friends.96142ff5.jpg";